import type { FormProps } from '../../types'
import { useController } from 'react-hook-form'
import { Switch } from '../../../components/ui/switch'

export interface CustomSwitchInput {
  name: string
  type: string
  customControlType: 'switch'
  validation?: {
    required?: boolean
  }
  uiOptions?: {
    testId?: string
  }
}

export type CustomSwitchProps = {
  field: CustomSwitchInput
  formProps: FormProps
}

export default function CustomSwitch({ field, formProps }: CustomSwitchProps) {
  const { field: controllerField } = useController({
    control: formProps.control,
    name: `${field.name}`,
    defaultValue: false,
  })

  return (
    <div className="flex flex-col gap-1 py-2 w-full">
      <div className="flex flex-row items-center justify-between gap-4 my-2">
        <Switch
          onCheckedChange={controllerField.onChange}
          checked={controllerField.value}
        />
      </div>
    </div>
  )
}
